module.exports = __webpack_public_path__ + "img/phone-arrow-down-left.d27fb9c4.svg";